<template>
    <div class="HomeEvalDir">
        <div class="titlePage">Evaluación Jefe Inmediato</div>
        <i class="fa fa-spinner fa-spin fa-3x fa-fw iconload" aria-hidden="true" v-if="iconLoad"></i>
        <va-notification v-if="evalsExist === false" color="danger" class="refNoData">No se encuentran formularios activos
            en este momento.</va-notification>
        <va-notification v-if="isBadDate" color="danger" class="refNoData">No se encuentran formularios activos en este
            momento.</va-notification>
        <template v-else-if="evalsExist">
            <h2>Selecciona un periodo Académico</h2>
            <!-- Select Principal (Pregunta el periodo necesitado) -->
            <select name="nperiod" id="period" class="showperiods" v-model="perselected"
                @change="getEvalInfo($event, perselected, first_filter)" required>
                <option v-for="(period, a) in periods" :value="period" :key="a">{{ period }}</option>
            </select>
            <div class="evalDList" v-for="(program, index) of programs" :key="index">
                <div class="evalDlisHead" @click="openList(index)">Docentes con contrato en el programa: {{ program }} <i class="fa fa-angle-down"
                        aria-hidden="true"></i></div>
                <div class="evalDlistContent">
                    <div class="evalDlistResume">
                        <h3>Información</h3>
                        <p>Nombre del programa: <span>{{ program }}</span></p>

                        <p>Periodo: <span>{{ perselected }}</span></p>
                    </div>
                    <div class="evalDlistInfo">
                        <div class="evalDlistInfoB">
                            <h3>Instrucciones</h3>
                            <p>Progreso de la Evaluación del jefe inmediato para {{ program }} en el periodo {{ perselected }}.
                            </p>
                            <p><span>1) </span> Visualizar la autoevaluación del docente.</p>
                            <p><span>2) </span> Visualizar la evaluación docente por parte de los estudiantes.</p>
                            <p><span>3) </span> Verificar si el docente cuenta con la opción de evaluar para realizar el
                                proceso.</p>
                        </div>
                    </div>
                    <div class="evalDlistTeachers">
                        <h3>Docentes</h3>
                        <div class="teacherHeader">
                            <div>Id Banner</div>
                            <div>Nombre</div>
                            <div>Autoevaluación</div>
                            <div>Ev Docente</div>

                            <div>Acciones</div>
                        </div>
                        <div
                            v-for="pp in second_filter"
                            :key="`${pp.idbanner_docente}-${pp.codigo_programa}-${program}`"
                            class="teacherTab"
                            v-if="pp.nombre_programa == program">
                                <div class="teachercol">{{ pp.idbanner_docente }}</div>
                                <div class="teachercol">{{ pp.nombre_docente }}</div>
                                <div class="teachercol">
                                    <span
                                        @click="showAutoEvaluation(pp.idbanner_docente, pp.codigo_programa, perselected, 'a')"><i class="fa fa-eye" aria-hidden="true"></i>
                                        Autoevaluación</span>
                                    <div :id="pp.idbanner_docente + pp.codigo_programa + perselected + 'a'"
                                        class="modalList">

                                        <div class="modalListHeader">
                                            <p>Autoevaluación</p>
                                            <span
                                                @click="hiddenModal(pp.idbanner_docente, pp.codigo_programa, perselected, 'a')"
                                                class="hiddenModal fa fa-times"></span>
                                        </div>
                                        <div class="modalListContent">
                                            {{ messageautoev }}
                                        </div>
                                    </div>
                                </div>
                                <div class="teachercol">
                                    <span
                                        @click="showTeacherEvaluation(pp.idbanner_docente, pp.codigo_programa, perselected, 'e', pp.nrc, program)"><i class="fa fa-eye" aria-hidden="true"></i> Ev Estudiantes</span>
                                    <div :id="pp.idbanner_docente + pp.codigo_programa + perselected + 'e'"
                                        class="modalList">
                                        <div class="modalListHeader">
                                            <p>Ev Estudiantes</p>
                                            <span
                                                @click="hiddenModal(pp.idbanner_docente, pp.codigo_programa, perselected, 'e')"
                                                class="hiddenModal fa fa-times"></span>
                                        </div>
                                        <div class="modalListContent">
                                            <p v-for="(msevdo, index) of messageevdo" :key="index">
                                                {{ msevdo }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="teachercol ">
                                    <div v-if="pp.evaluado == 'evaluado'" class="formsucc">
                                        <p>Evaluado</p>
                                    </div>
                                    <div v-else-if="pp.evaluado == 'evaluar'" class="formtoev">
                                        <p @click="evaluateTeacher(
                                            perselected,
                                            'DIR-' + pp.codigo_programa,
                                            pp.id_person

                                        )">Evaluar</p>
                                    </div>
                                    <div v-else>{{ pp.evaluado }}</div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'

export default {
  data () {
    return {
      isEspecialYear: [],
      director: null,
      role: null,
      idPerson: null,
      periods: [],
      teachers: [],
      perselected: '',
      first_filter: [],
      second_filter: null,
      programs: [],
      messageautoev: '',
      messageevdo: [],
      autoevals: [],
      formType: null,
      chartColorA: '#f2a900',
      chartColorB: '#a2273c',
      iconLoad: true,
      evalsExist: null,
      isBadDate: false,
      form: null,
      roleUser: null,
    }
  },
  methods: {
    openList (index) {
      document.getElementsByClassName('evalDlistContent')[index].classList.toggle('evalDlistContentActive')
    },

    getRole () {
      const token = IberoHelpers.getToken(this.$store)
      token.then(tokenData => {
        const DirRoleData = IberoHelpers.getUserLoginAuth(this.$store, this.$session.get('IberoJWTAdminLogin').emailCorporative, tokenData)
        // const DirRoleData = IberoHelpers.getUserLoginAuth(this.$store, 'cindy.cordero@ibero.edu.co', tokenData);
        // const DirRoleData = IberoHelpers.getUserLoginAuth(this.$store, 'julio.moreno@ibero.edu.co')
        DirRoleData.then(dataRol => {
          const aux = dataRol.data[0].idUserType
          let rolee = 0
          let idp = dataRol.data[0].idBanner
          aux.map(function (value) {
            if (value.Cod_Role === 'DIR') {
              rolee = value.Id_Role
            }
          })
          this.role = rolee
          this.idPerson = idp
          if (this.role === 0) {
            console.warn('Código de error: #JISRA')
            this.isBadDate = true
            this.iconLoad = false
          } else {
            this.getPrograms(this.role)
            this.getForm(this.role)
          }
        })
      })
    },

    /*
            10 - 20 (pregrado)
            11 -12- 13- 16 y 17 (pregrado virtual)
            31 - 32 - 33 -34 -35 (pregrado virtual)
            41 - 42- 43 -44 -45 (posgrado)
            51 -52 -53 -54 y 55 (posgrado)
        */

    getForm (role) {
      const currentDate = new Date()
      const form = IberoHelpers.getFormType(this.$store, 'EDIR')
      form.then(formType => {
        this.formType = formType.data[0].Id_Form_Type
        // const datEvalForm = IberoHelpers.getEvalForm(this.$store, role, 2021, this.formType)
        const datEvalForm = IberoHelpers.getEvalForm(this.$store, role, currentDate.getFullYear(), this.formType)
        datEvalForm.then(Response => {
          let currentDateSet
          this.period = Response.data[0].Id_Period
          currentDate.setDate(currentDate.getDate())
          currentDateSet = currentDate.getFullYear() + '-' + ('0' + (currentDate.getMonth() + 1)).slice(-2) + '-' + ('0' + currentDate.getDate()).slice(-2)
          let d1 = Response.data[0].Date_Form_Start.split('-')
          let d2 = Response.data[0].Date_Form_End.split('-')
          let c = currentDateSet.split('-')

          /* -------------------------------------------------------------- */
          let from = new Date(d1[0], parseInt(d1[1]) - 1, d1[2])
          let to = new Date(d2[0], parseInt(d2[1]) - 1, d2[2])
          let check = new Date(c[0], parseInt(c[1]) - 1, c[2])
          /* -------------------------------------------------------------- */
          if ((check >= from) && (check <= to)) {
            // this.getFormId(role, 2021, this.formType)
            this.getFormId(role, currentDate.getFullYear(), this.formType)
          } else {
            this.isBadDate = true
            this.iconLoad = false
          }
        })
      })
    },
    getFormId (role, actualPeriod, formType) {
      const dataForm = IberoHelpers.getEvalForm(this.$store, role, actualPeriod, formType)
      dataForm.then(getForm => {
        this.isEspecialYear = []
        if (getForm.data) {
          this.isEspecialYear.push({
            year: getForm.data[0].Id_Period,
          })
          this.evalsExist = true
          this.form = getForm.data[0].Id_Generic_Form
          this.roleUser = role
          this.iconLoad = false
        } else {
          this.evalsExist = false
          this.iconLoad = false
        }
      })
    },
    getPrograms (role) {
      // const DirProgramData = IberoHelpers.getDirectorPrograms(this.$store, '100048261', role)
      const DirProgramData = IberoHelpers.getDirectorPrograms(this.$store, this.$session.get('IberoJWTAdminLogin').idBanner, role)
      DirProgramData.then(dataProgram => {
        let degrees = []
        let programSet = new Set()
        this.teachers = []
        for (let i = 0; i < dataProgram.data.length; i++) {
          let programId = dataProgram.data[i].Id_Program
          let teacherId = dataProgram.data[i].Id_Banner_Docente
          this.teachers.push({
            id_program: programId,
            id_teacher: teacherId,
          })
          if (!programSet.has(programId)) {
            programSet.add(programId)
            let obj = {
              id: degrees.length,
              degree: programId,
            }
            degrees.push(obj)
          }
        }
        this.getPeriods(degrees)
      })
    },
    async waitForData () {
      let attempts = 0
      const maxAttempts = 7

      while ((!this.isEspecialYear.length || !this.isEspecialYear[0].year) && attempts < maxAttempts) {
        console.warn(`Esperando datos de isEspecialYear... Intento ${attempts + 1}`)
        await new Promise(resolve => setTimeout(resolve, 100)) // Espera 100ms antes de volver a verificar
        attempts++
      }

      if (attempts >= maxAttempts) {
        console.error('Se alcanzó el máximo de intentos. isEspecialYear no está disponible.')
        this.isBadDate = true
      }
    },
    // ============================================================================================================
    async getPeriods (degrees) {
      await this.waitForData()
      const d = new Date()
      let year = d.getFullYear()
      let validatedYear = null
      let isEspecialCase = false

      if (year === this.isEspecialYear[0].year) {
        validatedYear = year
      } else {
        validatedYear = this.isEspecialYear[0].year
        isEspecialCase = true
      }
      let periods = []
      this.first_filter = []

      const validPeriodEndings = [17, 35, 45, 55, 56] // Sufijos válidos de periodo

      // Recorre los degrees
      for (let i = 0; i < degrees.length; i++) {
        let associatedTeachers = this.teachers.filter(teacher => teacher.id_program === degrees[i].degree)
        let nombrePrograma = ''
        for (let teacher of associatedTeachers) {
          const data = IberoHelpers.GetTeacherByCodigo(this.$store, teacher.id_teacher, validatedYear)
          data.then(responseData => {
            for (let j = 0; j < responseData.data.length; j++) {
              // Verifica si el código del programa coincide con el degree actual
              if (degrees[i].degree === responseData.data[j].codigo_programa) {
                nombrePrograma = responseData.data[j].nombre_programa
                break
              }
            }

            for (let j = 0; j < responseData.data.length; j++) {
              let currentPeriod = responseData.data[j].periodo

              // Aplica el filtro si es un caso especial
              if (!isEspecialCase || validPeriodEndings.some(ending => currentPeriod.endsWith(ending))) {
                if (!periods.includes(currentPeriod)) {
                  periods.push(currentPeriod)
                }

                let obj = {
                  codigo_programa: degrees[i].degree,
                  idbanner_docente: teacher.id_teacher,
                  nombre_docente: responseData.data[j].nombre_docente,
                  nombre_programa: nombrePrograma,
                  periodo: currentPeriod,
                }

                let exists = this.first_filter.some(item =>
                  item.codigo_programa === obj.codigo_programa &&
                                    item.idbanner_docente === obj.idbanner_docente &&
                                    item.nombre_docente === obj.nombre_docente &&
                                    item.nombre_programa === obj.nombre_programa &&
                                    item.periodo === obj.periodo
                )

                // Solo lo agrega si no existe en first_filter
                if (!exists) {
                  this.first_filter.push(obj)
                }
              }
            }

            // Ordena y asigna los períodos únicos
            this.periods = [...new Set(periods)].sort()

            // Verifica si hay períodos, si no, evalsExist se pone en false
            this.evalsExist = this.periods.length > 0
          })
        }
      }
    },
    // ====================================================================================================================
    // Por mirar: Por que no se ejecuta?
    // observacion: llena el Select Principal.
    getEvalInfo (event, period, firstFilter) {
      // first_filter: contiene el total de docentes
      this.programs = []
      // -----------------------------------------------------------
      // Por mirar: a que elemento se le asigna la clase 'activeModalList'
      let els = document.getElementsByClassName('activeModalList')
      for (let i = 0; i < els.length; i++) {
        els[i].classList.remove('activeModalList')
      }
      // ------------------------------------------------------------
      let elss = document.getElementsByClassName('evalDlistContent')
      for (let i = 0; i < elss.length; i++) {
        elss[i].classList.remove('evalDlistContentActive')
      }
      if (period !== '') {
        let dataFilter = firstFilter.filter(element => {
          return period.includes(element.periodo)
        })

        // data_filter.sort(function (a, b) {
        //     return a.idbanner_docente.localeCompare(b.idbanner_docente);
        // })

        dataFilter.sort((a, b) => a.idbanner_docente > b.idbanner_docente ? 1 : (a.idbanner_docente < b.idbanner_docente ? -1 : 0))

        const getProgramData = [...new Set(dataFilter.map(item => item.nombre_programa))]
        for (let j = 0; j < getProgramData.length; j++) {
          this.programs.push(getProgramData[j])
        }

        // por mirar: donde estan igualando a data filter con data filter2
        let dataFilter2 = []
        let dataFilter3 = []
        // filtro data_filter2
        for (let k = 0; k < dataFilter.length; k++) {
          // compara los datos con filter1
          // pregunta: se supone que el filtro debe quedar bacio?
          // esta comparando el filtro 1 con el filtro 2 que supuesta
          let found = dataFilter2.filter(element => element.idbanner_docente === dataFilter[k].idbanner_docente)
          if (found.length === 0) {
            let obj = {
              // codigo_materia: dataFilter[k].codigo_materia,
              codigo_programa: dataFilter[k].codigo_programa,
              idbanner_docente: dataFilter[k].idbanner_docente,
              nombre_docente: dataFilter[k].nombre_docente,
              nombre_programa: dataFilter[k].nombre_programa,
              // nrc: [dataFilter[k].nrc],
              periodo: dataFilter[k].periodo,
            }
            dataFilter2.push(obj)
          }
          // else {
          //     let dataexist = 0
          //     for (let l = 0; l < found.length; l++) {
          //         if ((found[l].idbanner_docente === data_filter[k].idbanner_docente) && (found[l].codigo_programa == data_filter[k].codigo_programa)) {
          //             found[l].nrc.push(data_filter[k].nrc)
          //             dataexist = 1
          //         }
          //     }
          //     if (dataexist == 0) {
          //         let obj = {
          //             //holaaa
          //             //codigo_materia: data_filter[k].codigo_materia,
          //             codigo_programa: data_filter[k].codigo_programa,
          //             idbanner_docente: data_filter[k].idbanner_docente,
          //             nombre_docente: data_filter[k].nombre_docente,
          //             nombre_programa: data_filter[k].nombre_programa,
          //             //nrc: [data_filter[k].nrc],
          //             periodo: data_filter[k].periodo
          //         }
          //         data_filter2.push(obj)
          //     }
          // }
        }
        for (let l = 0; l < dataFilter2.length; l++) {
          // teacherData.then(teacherResponse => {
          // if (teacherResponse.data) {
          // ===========================================================================================================
          let successEv = IberoHelpers.GetFormSuccessDDV(this.$store, 0, dataFilter2[l].idbanner_docente, dataFilter2[l].periodo, 'DIR-' + dataFilter2[l].codigo_programa.toUpperCase())
          // let successEv = IberoHelpers.GetFormSuccessDDV(this.$store, this.idPerson, data_filter2[l].idbanner_docente, data_filter2[l].periodo, 'DIR-' + data_filter2[l].codigo_programa.toUpperCase())
          successEv.then(successData => {
            if (successData.data) {
              // evaluado
              let obj = {
                // codigo_materia: data_filter2[l].codigo_materia,
                codigo_programa: dataFilter2[l].codigo_programa,
                idbanner_docente: dataFilter2[l].idbanner_docente,
                nombre_docente: dataFilter2[l].nombre_docente,
                nombre_programa: dataFilter2[l].nombre_programa,
                // nrc: data_filter2[l].nrc,
                periodo: dataFilter2[l].periodo,
                evaluado: 'evaluado',
                id_person: dataFilter2[l].idbanner_docente,
              }
              dataFilter3.push(obj)
            } else {
              // por evaluar
              let obj = {
                // codigo_materia: data_filter2[l].codigo_materia,
                codigo_programa: dataFilter2[l].codigo_programa,
                idbanner_docente: dataFilter2[l].idbanner_docente,
                nombre_docente: dataFilter2[l].nombre_docente,
                nombre_programa: dataFilter2[l].nombre_programa,
                // nrc: data_filter2[l].nrc,
                periodo: dataFilter2[l].periodo,
                evaluado: 'evaluar',
                id_person: dataFilter2[l].idbanner_docente,
              }
              dataFilter3.push(obj)
            }
          })
          // ===========================================================================================================
          // }
          // else {
          //     // docente error intranet
          //     let obj = {
          //         //codigo_materia: data_filter2[l].codigo_materia,
          //         codigo_programa: data_filter2[l].codigo_programa,
          //         idbanner_docente: data_filter2[l].idbanner_docente,
          //         nombre_docente: data_filter2[l].nombre_docente,
          //         nombre_programa: data_filter2[l].nombre_programa,
          //         //nrc: data_filter2[l].nrc,
          //         periodo: data_filter2[l].periodo,
          //         evaluado: 'El docente no existe en Intranet'
          //     }
          //     data_filter3.push(obj)
          // }
          // })
        }
        this.second_filter = dataFilter3
      }
    },
    showAutoEvaluation (idbanner, degree, period, type) {
      this.messageautoev = 'Cargando autoevaluación...'
      let els = document.getElementsByClassName('activeModalList')
      for (let i = 0; i < els.length; i++) {
        els[i].classList.remove('activeModalList')
      }
      document.getElementById(idbanner + degree + period + type).classList.toggle('activeModalList')

      let successEv = IberoHelpers.GetFormSuccessDDV(this.$store, idbanner, idbanner, period, period)
      successEv.then(successData => {
        if (successData.data) {
          let requestEV = successData.data[0].Request
          let obja
          try {
            obja = JSON.parse(requestEV)
          } catch (error) {
            console.error('Error al interpretar la autoevaluación:', error)
            this.messageautoev = 'Docente sin Autoevaluación'
            return
          }
          let totalVal = 0
          let countq = 0

          for (let i in obja) {
            if (parseInt(obja[i]) > 0) {
              totalVal += parseInt(obja[i])
              countq++
            }
          }

          let totalEv = Math.round((totalVal / countq) * 10) / 10
          const convertedTotalEv = ((totalEv - 1) / (4 - 1)) * (5 - 1) + 1
          this.messageautoev = 'Autoevaluación: ' + convertedTotalEv.toFixed(2)
        } else {
          this.messageautoev = 'Docente sin Autoevaluación'
        }
      })
    },
    hiddenModal (idbanner, degree, period, type) {
      document.getElementById(idbanner + degree + period + type).classList.remove('activeModalList')
    },
    async showTeacherEvaluation (idbanner, degree, period, type, nrc, signature) {
      const els = document.getElementsByClassName('activeModalList')
      for (let i = 0; i < els.length; i++) {
        els[i].classList.remove('activeModalList')
      }

      document.getElementById(idbanner + degree + period + type).classList.toggle('activeModalList')

      this.messageevdo = ['Cargando evaluación...']

      try {
        const average = await IberoHelpers.getTeacherAverage(this.$store, idbanner, period)
        if (average && average.data[0] && average.data[0].average) {
          const convertedAverage = ((average.data[0].average - 1) / (4 - 1)) * (5 - 1) + 1
          this.messageevdo = [`Promedio total por periodo: ${convertedAverage.toFixed(2)}`]
        } else {
          this.messageevdo = ['Sin evaluación']
        }
      } catch (error) {
        console.error('Error al obtener la evaluación:', error)
        this.messageevdo = ['Error al cargar la evaluación']
      }
    },
    evaluateTeacher (period, signature, idToEval) {
      const evalData = {
        form: this.form,
        period: period,
        signature: signature,
        id_person: this.idPerson,
        id_to_eval: idToEval,
        form_type: this.formType,
        role: this.roleUser,
      }
      this.$session.set('evalDir', evalData)
      this.$router.push('/admin/FormEvalDirector/')
    },
  },
  mounted: async function () {
    let loader = this.$loading.show()
    try {
      await this.getRole()
    } catch (error) {
      console.error('Error durante el proceso de obtención de datos:', error)
      // this.iconLoad = false;
    } finally {
      loader.hide()
    }
  },
}
</script>